import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import Card from "../../components/Cards/Card";
import KpiCardOverview from "../../components/KpiCardOverview/KpiCardOverview";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "94%",
  justifyContent: "flex-start",
  width: "100%",
});

function OpportunitiesDesktop({ app, config }) {
  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutCardsWrapper>
          <Grid container rowGap={2} marginTop={"29px"}>
            <Grid item width={"100%"}>
              <LayoutCardWrapper className={"container-table"}>
                <Card
                  app={app}
                  style={{ width: "100%", height: "100%" }}
                  className={"container-table"}
                >
                  <div className="contianerKPis">
                    <div className="kpaiCardFase">
                      <div className="columnLeft">
                        <p className="title">faseamento</p>
                        <p className="day-total">
                          dias totais:
                          <span>
                            <NativeObject
                              app={app}
                              key="nmpCyyd"
                              reference={{ id: "nmpCyyd" }}
                              style={{
                                width: "29px",
                                height: "15px",
                              }}
                            />
                          </span>
                        </p>
                        <p className="day-trans">
                          Dias transc.:
                          <span>
                            <NativeObject
                              app={app}
                              key="jJHjSn"
                              reference={{ id: "jJHjSn" }}
                              style={{
                                minWidth: "25px",
                                height: "15px",
                              }}
                            />
                          </span>
                        </p>
                      </div>
                      <div className="columnRight">
                        <NativeObject
                          app={app}
                          key="GgVZbvQ"
                          reference={{ id: "GgVZbvQ" }}
                          style={{
                            width: "29px",
                            height: "25px",
                          }}
                        />
                      </div>
                    </div>

                    <KpiCardOverview
                      app={app}
                      KPITitle={"ST Aero CX"}
                      valueId={"XMnGuq"}
                      goalValueId={"XMnGuq"}
                      percentageId={"XMnGuq"}
                      hasProgressBar={true}
                      fullView
                    />

                    <KpiCardOverview
                      app={app}
                      KPITitle={"ST LED CX"}
                      valueId={"UKeJJ"}
                      goalValueId={"UKeJJ"}
                      percentageId={"UKeJJ"}
                      hasProgressBar={true}
                      fullView
                    />

                    <KpiCardOverview
                      app={app}
                      KPITitle={"ST PIR CX"}
                      valueId={"XPbTC"}
                      goalValueId={"XPbTC"}
                      percentageId={"XPbTC"}
                      hasProgressBar={true}
                      fullView
                    />

                    <KpiCardOverview
                      app={app}
                      KPITitle={"CLC AERO"}
                      valueId={"gwUrv"}
                      goalValueId={"gwUrv"}
                      percentageId={"gwUrv"}
                      hasProgressBar={true}
                      fullView
                    />

                    <KpiCardOverview
                      app={app}
                      KPITitle={"CLC LED"}
                      valueId={"KZRnsD"}
                      goalValueId={"KZRnsD"}
                      percentageId={"KZRnsD"}
                      hasProgressBar={true}
                      fullView
                    />

                    <KpiCardOverview
                      app={app}
                      KPITitle={"CLC PIR"}
                      valueId={"gRDtFuE"}
                      goalValueId={"gRDtFuE"}
                      percentageId={"gRDtFuE"}
                      hasProgressBar={true}
                      fullView
                    />
                  </div>

                  <NativeObject
                    app={app}
                    key="njLAhFT"
                    reference={{ id: "njLAhFT" }}
                    style={{ height: "calc(100vh - 200px)" }}
                  />
                </Card>
              </LayoutCardWrapper>
            </Grid>
          </Grid>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

OpportunitiesDesktop.defaultProps = {
  app: null,
  config: {},
};

OpportunitiesDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OpportunitiesDesktop;
